<div class="ion-page">
  <ind-header-tabs
    [tabs]="tabsData"
    [selectedTab]="selectedTab"
    (tabChange)="selectTab($event)">
  </ind-header-tabs>

  <ion-grid no-padding class="content-page"
    [ngClass]="showDetailOrNew ? 'preview-active' : 'preview-inactive'">
    <ion-row no-padding>
      <ion-col no-padding class="mi-left-pane">
        <medical-inquiry-list [selectedTab]="selectedTab"></medical-inquiry-list>
      </ion-col>
      <ion-col no-padding class="mi-right-pane">
        <ion-nav #medicalinquiryrightpane></ion-nav>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
